module.exports = __webpack_public_path__ + "img/3d-painting_jp.b7fa5a6.jpg";